// extracted by mini-css-extract-plugin
export default {"footer-container":"Footer_footer-container__Hl-ha","hr":"Footer_hr__q4d9l","curawella":"Footer_curawella__aJykG"};